import GenericPossessionInfo from './GenericPossessionInfo';

const RealEstateInfo = ({ customerRecords }) => (
  <GenericPossessionInfo
    customerRecords={customerRecords}
    possessionsKey="real_estate"
    optionLabel={(p) => [p.address1, p.city].filter(Boolean).join(', ') || 'Property'}
  />
);

export default RealEstateInfo;
